import parseCookies from "./parseCookies";

export default function getSnowplowIdCookie() {
  const SP_COOKIE_NAME_REGEX = /_sp_id\.[a-f0-9]+/;
  if (document) {
    const cookies = parseCookies();
    const keys = Object.keys(cookies)
    const spCookieKey = keys.find(key => SP_COOKIE_NAME_REGEX.test(key))
    if (spCookieKey) {
      return cookies[spCookieKey]
    }
  }

  return null
}